<template>
  <div>
    <p class="body-1 mb-16">
      {{ i18n(translations.title) }}
    </p>

    <div class="text-center">
      <RevIllustration
        :alt="i18n(translations.altText)"
        :height="477"
        src="/img/empty.svg"
        :width="477"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'

import translations from './EmptyState.translations'

const i18n = useI18n()
</script>
